import React from 'react'
import { useHistory } from 'react-router-dom'
import StorageCreateInvoice from '../../../components/Storage/StorageCreateInvoice'
import axios from 'axios'
import { useSelector } from 'react-redux'
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "../../../src/components/shadui/ui/alert-dialog"
import { t } from 'i18next'

function CafeteriaStorageDetails() {
    const currentCenterId = '66bdca9b7add38fef2918d63'
    const currentUser = useSelector((state) => state.authentication.user);
    const history = useHistory()
    const [alertOpen, setAlertOpen] = React.useState(false)
    const [expensesChecked, setExpensesChecked] = React.useState(true)
    const [items, setItems] = React.useState([])

    const onClickSubmit = async () => {
        try {
            if (expensesChecked === null || items.length === 0) {
                alert('Please select if it is add expense or not')
                return
            }
            const newItems = items

            const res = await axios.put('/cafeteria-storage/' + currentCenterId, { items: newItems, adminId: currentUser._id, expensesChecked })

            history.goBack()
            setAlertOpen(false)
        } catch (e) {
            console.log({ e })
            alert('error')
            throw e
        }
    }

    const onHandleExpense = (e) => {
        setExpensesChecked(e.target.value === 'true')
    }

    const handleExpenseModal = (items) => {
        setAlertOpen(!alertOpen)
        setItems(items)
    }

    return (
        <div className='flex w-full h-full bg-white' >
            <AlertDialog open={alertOpen} >
                <AlertDialogContent>
                    <AlertDialogHeader>
                        <AlertDialogTitle>{t('Please make sure the items are correct')}</AlertDialogTitle>
                        <AlertDialogDescription>
                            {t(`This action cannot be undone`)}
                        </AlertDialogDescription>
                    </AlertDialogHeader>
                    <div className='flex flex-col' >
                        {t('Do you want it to be expense?')}
                        <div className='flex gap-x-1' >
                            <div className='mr-2' ><input onChange={onHandleExpense} type='radio' checked={expensesChecked === true} name='expense' value='true' /> {t('Yes')}</div>
                            <> <input type='radio' onChange={onHandleExpense} name='expense' value='false' checked={expensesChecked === false} /> {t('No')}</>
                        </div>
                    </div>
                    <AlertDialogFooter>
                        <AlertDialogCancel onClick={() => { setAlertOpen(false) }} >{t('Cancel')}</AlertDialogCancel>
                        <AlertDialogAction onClick={onClickSubmit}>{t('Continue')}</AlertDialogAction>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
            {true ? <div className='flex flex-col w-full h-full' >
                <StorageCreateInvoice currencyType='iqd' stockQuery={'/cafeteria-stocks'} onClickSubmit={handleExpenseModal} />
            </div> : null}
        </div>
    )
}

export default CafeteriaStorageDetails
